console.log('✅ ship-to-country-top.js loaded successfully!');

// Efficient top-level imports for frequently used core modules
import { APP_CONFIG } from '../../js/config.js';
import { getTextTranslationByKey } from '../../js/translator.js';
import { getLinksTranslationByKey } from '../../js/router-routes-manager.js';
import { appState, getArrowToggleDownIconSVG } from '../../js/state.js';
import { registerEventListenerToAttach } from '../../js/to-attach-event-listener-registry.js';
import {
  saveToLocalStorage,
  loadFromLocalStorage,
  saveToLocalStorageWithLimitAndExpiry,
} from '../../js/utils-local-storage.js';

import {
    fetchCountries,
    fetchStates,
    fetchCities
} from '../../services/data-services/country-state-city-data-service.js';

export async function buildComponentShipToCountryTop() {
  console.log(`🔄 Building Component: ShipToCountryTop - lang: ${appState.SiteLanguageCookie}`);

  try {
    // so it ends up in its own "translation-service" chunk:
    const { loadMyTranslationsService } = await import(
      /* webpackChunkName: "translation-service" */
      /* webpackPrefetch: true */
      '../../services/my-translator-service.js'
    );

    // 1) Load translations in parallel (cached after first call)
    const { _tempTextTranslator, _tempLinksTranslator } = await loadMyTranslationsService(
      appState.SiteLanguageCookie
    );

    const {
      keyShipTo: lblShipTo,
      keyCountry: textkeyCountry,
      keyShipToCountry: textkeyShipToCountry,
      keyStateOrRegion: textkeyStateOrRegion,
      keyCityOrTown: textkeyCityOrTown,
      keyApplyChanges: textkeyApplyChanges,
    } = _tempTextTranslator;

    const { keyMyMessages: linkMyMessages } = _tempLinksTranslator;

    // get values from AppState - not using localsotrage to get this incase local storage is not set

    const selectedCountryCode = appState?.SiteShipToCountryCodeTwoCookie || 'gb';
    const selectedCountryCode3 = appState?.SiteShipToCountryCodeThreeCookie || 'GBR';
    const selectedCountryName = appState?.SiteShipToCountryNameCookie || 'United Kingdom';

    const imgSrcForFlags = `${APP_CONFIG.IMAGES_BASE_URL}imgs/flags/`;

    const lblDisplayShipToCountryFlagImg = `${imgSrcForFlags}${selectedCountryCode}.png`;

    const html = `
            <div class="divTopShipToCountryWrapper" tabindex="0">
                <div id="dropbtnSelectSiteShipToCountry-Button">
                    <div class="ship-to-container">
                        <div class="ship-to-label">${lblShipTo}</div>
                        <img id="imgSiteShipToCountry" class="ship-to-flag" alt="${textkeyCountry}" 
                             src="${lblDisplayShipToCountryFlagImg}" width="24" height="16" />
                        <div class="ship-to-code">${selectedCountryCode3}</div>                       
                         <svg fill="#555" height="20px" width="20px" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" class="ship-to-dropdown">
      <path d="M13.708 6.29A1.006 1.006 0 0 0 13 6H5.005A1 1 0 0 0 4.3 7.71l4 4a1.013 1.013 0 0 0 1.42 0l4-4a1.01 1.01 0 0 0-.013-1.42z"></path>
    </svg>
                    </div>
                </div>

                <div id="dropDownSelectSiteShipToCountry" class="dropbtnSelectSiteShipToCountry-content" style="display: none;">
                    <div style="display:block;width:300px;">
                        <button class="divShipToCountryClose">x</button><br/><br/>
                        <label>${textkeyShipToCountry}</label><br/>
                        <select id="DropDownSiteShipToCountry" style="width:100%;"></select>
                        <br/><br/>
                        <label>${textkeyStateOrRegion}</label><br/>
                        <select id="DropDownSiteShipToState" style="width:100%;"></select>
                        <br/><br/>
                        <label>${textkeyCityOrTown}</label><br/>
                        <select id="DropDownSiteShipToCity" style="width:100%;"></select>
                        <br/><br/>
                        <button id="btnApplyShipToCountry" class="my-basic-btn my-basic-width-100 my-basic-padding-10">
                            ${textkeyApplyChanges}
                        </button>
                    </div>
                </div>
            </div>`;

    console.log('✅ ShipToCountryTop built successfully.');

    // Register the event listener only when the component is built
    //registerEventListenerToAttach(attachEventListenersShipToCountryTop);

    registerEventListenerToAttach(async () => initComponentShipToCountryTop());

    return html;
  } catch (err) {
    console.error('❌ Error building ShipToCountryTop:', err);
    return '<div>Error loading Ship To Country selector</div>';
  }
}

export async function initComponentShipToCountryTop() {
  try {
    const shipToCountryButton = document.querySelector('#dropbtnSelectSiteShipToCountry-Button');
    const dropdown = document.querySelector('#dropDownSelectSiteShipToCountry');
    const btnApply = document.querySelector('#btnApplyShipToCountry');
    const closeBtn = document.querySelector('.divShipToCountryClose');
    const countryDropdown = document.querySelector('#DropDownSiteShipToCountry');
    const stateDropdown = document.querySelector('#DropDownSiteShipToState');
    const cityDropdown = document.querySelector('#DropDownSiteShipToCity');

    if (
      !dropdown ||
      !shipToCountryButton ||
      !btnApply ||
      !countryDropdown ||
      !stateDropdown ||
      !cityDropdown
    ) {
      console.warn('⚠️ Some required elements not found, skipping ShipToCountryTop setup.');
      return;
    }

    let isDropdownOpen = false;

    const toggleDropdownHandler = async () => {
      isDropdownOpen = !isDropdownOpen;
      dropdown.style.display = isDropdownOpen ? 'block' : 'none';

      if (isDropdownOpen) {
        console.log('🌐 Populating countries on dropdown open');
        await populateCountryDropdown();
        countryDropdown.value = appState?.SiteShipToCountryIDCookie;
        await updateStateDropdown(countryDropdown.value);
        stateDropdown.value = appState?.SiteShipToStateIDCookie;
        await updateCityDropdown(stateDropdown.value);
        cityDropdown.value = appState?.SiteShipToCityCookie;
        console.log('✅ States and cities loaded based on selected country');
      }
    };

    const closeDropdownHandler = () => {
      isDropdownOpen = false;
      dropdown.style.display = 'none';
    };

    const applyHandler = async () => {
      await applyChanges();
      isDropdownOpen = false;
    };

    const countryChangeHandler = async event => {
      const selectedCountryId = event.target.value;
      await updateStateDropdown(selectedCountryId);
      await updateCityDropdown(stateDropdown.value);
    };

    const stateChangeHandler = async event => {
      const selectedStateId = event.target.value;
      console.log('Selected state ID:', selectedStateId);
      await updateCityDropdown(selectedStateId);

      const selectedState = {
        id: selectedStateId,
        name: event.target.options[event.target.selectedIndex].text,
      };
      const storageKey = `states_${appState.SiteLanguageCookie}`;
      saveToLocalStorageWithLimitAndExpiry(storageKey, selectedState);
      console.log(`✅ Saved selected state:`, selectedState.name);
    };

    const cityChangeHandler = event => {
      const selectedCity = {
        id: event.target.value,
        name: event.target.options[event.target.selectedIndex].text,
      };
      const storageKey = `cities_${appState.SiteLanguageCookie}`;
      saveToLocalStorageWithLimitAndExpiry(storageKey, selectedCity);
      console.log(`✅ Saved selected city:`, selectedCity.name);
    };

    // Remove existing listeners first to avoid duplicates
    shipToCountryButton.removeEventListener('click', toggleDropdownHandler);
    shipToCountryButton.addEventListener('click', toggleDropdownHandler);

    closeBtn?.removeEventListener('click', closeDropdownHandler);
    closeBtn?.addEventListener('click', closeDropdownHandler);

    btnApply.removeEventListener('click', applyHandler);
    btnApply.addEventListener('click', applyHandler);

    countryDropdown.removeEventListener('change', countryChangeHandler);
    countryDropdown.addEventListener('change', countryChangeHandler);

    stateDropdown.removeEventListener('change', stateChangeHandler);
    stateDropdown.addEventListener('change', stateChangeHandler);

    cityDropdown.removeEventListener('change', cityChangeHandler);
    cityDropdown.addEventListener('change', cityChangeHandler);

    document.removeEventListener('click', closeDropdownHandler);
    document.addEventListener('click', event => {
      if (!dropdown.contains(event.target) && !shipToCountryButton.contains(event.target)) {
        closeDropdownHandler();
      }
    });

    console.log('✅ ShipToCountryTop event listeners attached.');
  } catch (error) {
    console.error('❌ Error attaching event listeners to ShipToCountryTop:', error);
  }
}



function closeDropdown() {
  const dropdown = document.querySelector('#dropDownSelectSiteShipToCountry');

  if (dropdown) {
    dropdown.style.display = 'none';
  }
}

/**
 * Apply country change and update the UI
 */
async function applyChanges() {
  const btnApply = document.querySelector('#btnApplyShipToCountry');

  // Add the loading class
  btnApply.classList.add('myloading');

  const countryDropdown = document.querySelector('#DropDownSiteShipToCountry');
  const stateDropdown = document.querySelector('#DropDownSiteShipToState');
  const cityDropdown = document.querySelector('#DropDownSiteShipToCity');

  const countryId = countryDropdown?.value || '237';
  const stateId = stateDropdown?.value || '0';
  const cityId = cityDropdown?.value || '0';

  // Get selected country details from the dropdown's data attributes
  const selectedOption = countryDropdown?.selectedOptions[0];
  const selectedCountryCode = selectedOption?.dataset.code || 'gb';
  const selectedCountryCode3 = selectedOption?.dataset.code3 || 'GBR';
  const selectedCountryName = selectedOption?.dataset.name || 'United Kingdom';

  // Update the displayed country code and flag image
  const countryCodeDiv = document.querySelector('.ship-to-code');
  const countryFlagImg = document.querySelector('#imgSiteShipToCountry');

  // doing the image first since it seesms to take longer to reflect
  if (countryFlagImg) {
    const imgSrcForFlags = `${APP_CONFIG.IMAGES_BASE_URL}imgs/flags/`;
    countryFlagImg.src = `${imgSrcForFlags}${selectedCountryCode.toLowerCase()}.png`;
    countryFlagImg.alt = selectedCountryName;
  }

  if (countryCodeDiv) {
    countryCodeDiv.textContent = selectedCountryCode3;
  }

  //update the app state
  appState.SiteShipToCountryIDCookie = countryId;
  appState.SiteShipToStateIDCookie = stateId;
  appState.SiteShipToCityCookie = cityId;
  appState.SiteShipToCountryCodeTwoCookie = selectedCountryCode;
  appState.SiteShipToCountryCodeThreeCookie = selectedCountryCode3;
  appState.SiteShipToCountryNameCookie = selectedCountryName;

  // Save the selected values to localStorage

  saveToLocalStorage('SiteShipToCountryIDCookie', countryId);
  saveToLocalStorage('SiteShipToStateIDCookie', stateId);
  saveToLocalStorage('SiteShipToCityCookie', cityId);
  saveToLocalStorage('SiteShipToCountryCodeTwoCookie', selectedCountryCode);
  saveToLocalStorage('SiteShipToCountryCodeThreeCookie', selectedCountryCode3);
  saveToLocalStorage('SiteShipToCountryNameCookie', selectedCountryName);

  // console.log(`✅ Applied and saved to localStorage:`, shipToData);

  // Optionally, refresh the page to apply changes
  //setTimeout(() => {
  //    window.location.reload();
  //}, 1000);

  // Remove the loading class after the method completes or 1 second (whichever is longer)
  setTimeout(() => {
    closeDropdown();

    btnApply.classList.remove('myloading');
  }, 2000);
}

async function populateCountryDropdown() {
  console.log('Populating Select Ship To Country Dropdown Top');

  const dropdown = document.querySelector('#DropDownSiteShipToCountry');
  const storageKey = `countries_${appState.SiteLanguageCookie}`;

  // Try to load from localStorage first
  const cachedCountries = loadFromLocalStorage(storageKey);

  // Check if we have valid cached data
  if (cachedCountries && Array.isArray(cachedCountries) && cachedCountries.length > 0) {
    console.log('✅ Loaded countries from cache');

    await renderCountryOptions(dropdown, cachedCountries);

    return;
  }

  // Fetch from the server if not cached or empty
  console.log('🌐 Fetching countries from server');

  const countries = await fetchCountries();
  if (countries.length === 0) return;

  await renderCountryOptions(dropdown, countries);
}

async function renderCountryOptions(dropdown, countries) {
  //  console.log(`🌐 Rendering country options for language: ${lang}`);

  //const lang = appState?.SiteLanguageCookie || "en";

  // ✅ Fetch all translations in parallel
  const [textkeySelectCountry] = await Promise.all([
    getTextTranslationByKey('keySelectCountry', appState.SiteLanguageCookie),
  ]);

  dropdown.innerHTML = `<option value="0">${textkeySelectCountry}</option>`;
  countries.forEach(country => {
    const option = document.createElement('option');
    option.value = country.countryID;
    option.textContent = country.name;

    // Add data attributes for code and code3
    option.dataset.code = country.countryCode.toLowerCase(); // Assuming 'code' is the 2-letter code
    option.dataset.code3 = country.countryCode3; // Assuming 'code3' is the 3-letter code
    option.dataset.name = country.name;

    dropdown.appendChild(option);
  });
}

async function updateStateDropdown(countryId) {
  console.log('Updating state dropdown for country ID:', countryId);

  // const lang = appState?.SiteLanguageCookie || "en";

  // ✅ Fetch all translations in parallel
  const [textkeySelectStateOrRegion] = await Promise.all([
    getTextTranslationByKey('keySelectStateOrRegion', appState.SiteLanguageCookie),
  ]);

  console.log('🌐 Fetching states from server for country ID:', countryId);

  const dropdown = document.querySelector('#DropDownSiteShipToState');
  dropdown.innerHTML = `<option value="0">${textkeySelectStateOrRegion}</option>`;

  const fetchPromise = await fetchStates(countryId);

  // Show spinner if loading takes more than 1 second
  let spinnerIsVisible = false;
  const delayPromise = new Promise(resolve => {
    setTimeout(() => {
      spinnerIsVisible = true;
      showSpinner('.currency-spinner');
      resolve();
    }, 1000);
  });

  // Apply the delay specifically in this method
  // const delayPromise = new Promise((resolve) => setTimeout(resolve, 1000));
  //const showSpinnerPromise = delayPromise.then(() => showSpinner(".state-spinner"));

  try {
    // Wait for both fetch and spinner delay
    await Promise.all([fetchPromise, delayPromise]);

    // Start both the spinner delay and the API call simultaneously
    // const states = await Promise.race([fetchStates(countryId), showSpinnerPromise]);

    const states = fetchPromise;

    states.forEach(state => {
      const option = document.createElement('option');
      option.value = state.stateID;
      option.textContent = state.stateName;
      dropdown.appendChild(option);
    });

    console.log('🌐 Fetched states from server for country ID:', countryId);
  } catch (error) {
    console.error('❌ Error loading states:', error);
  } finally {
    // Hide the spinner after loading is complete
    if (spinnerIsVisible) {
      hideSpinner('.state-spinner');
    }
  }
}

async function updateCityDropdown(stateId) {
  // const lang = appState?.SiteLanguageCookie || "en";

  // ✅ Fetch all translations in parallel
  const [textkeySelectCityOrTown] = await Promise.all([
    getTextTranslationByKey('keySelectCityOrTown', appState.SiteLanguageCookie),
  ]);

  const dropdown = document.querySelector('#DropDownSiteShipToCity');
  dropdown.innerHTML = `<option value="0">${textkeySelectCityOrTown}</option>`;

  console.log('🌐 Fetching cities from server for state ID:', stateId);

  const fetchPromise = await fetchCities(stateId);

  // Show spinner if loading takes more than 1 second
  let spinnerIsVisible = false;
  const delayPromise = new Promise(resolve => {
    setTimeout(() => {
      spinnerIsVisible = true;
      showSpinner('.currency-spinner');
      resolve();
    }, 1000);
  });

  try {
    // Wait for both fetch and spinner delay
    await Promise.all([fetchPromise, delayPromise]);

    // Start both the spinner delay and the API call simultaneously
    const cities = fetchPromise;

    cities.forEach(city => {
      const option = document.createElement('option');
      option.value = city.cityID;
      option.textContent = city.cityName;
      dropdown.appendChild(option);
    });

    console.log('🌐 Fetched cities from server for state ID:', stateId);
  } catch (error) {
    console.error('❌ Error loading cities:', error);
  } finally {
    // Hide the spinner after loading is complete
    if (spinnerIsVisible) {
      hideSpinner('.city-spinner');
    }
  }
}

function showSpinner(spinnerClass) {
  const spinner = document.querySelector(spinnerClass);
  if (spinner) spinner.style.display = 'inline-block';
}

function hideSpinner(spinnerClass) {
  const spinner = document.querySelector(spinnerClass);
  if (spinner) spinner.style.display = 'none';
}
